//Pasword validation
export function isValidPassword(input) {
  return passwordState(input) === true;
}

export function passwordState(input) {
  let result = passwordFeedback(input);
  return result === null ? null : result.length === 0;
}

export function passwordFeedback(input) {
  let issues = []
  if (input.length === 0) {
    return null;
  }
  if (input.length < 6)
    issues.push("less than 6 characters long");
  if (input.toLowerCase() === input)
    issues.push("missing an upper case letter");
  if (input.toUpperCase() === input)
    issues.push("missing a lower case letter");
  if (!/.*[0-9].*/.test(input)) {
    issues.push("missing a number");
  }
  if (/^[a-z0-9]+$/i.test(input)) {
    issues.push("missing a non-alphanumeric character");
  }
  return issues.length > 0 ? `Password is: ${issues.join(", ")}` : '';
}

//Confirm Pasword validation
export function isValidConfirmPassword(input, confirm) {
  return confirmPasswordState(input, confirm) === true;
}

export function confirmPasswordState(input, confirm) {
  let result = confirmPasswordFeedback(input, confirm);
  return result === null ? null : result.length === 0;
}

export function confirmPasswordFeedback(input, confirm) {
  if (confirm.length === 0){
    return null;
  }
  if (confirm !== input) {
    return "Password must match"
  } else {
    return "";
  }
}

export function isValidUrl(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}